/**
 * Browser-safe logger for client-side application code.
 *
 */

export const clientLogger = {
  debug(...args: unknown[]): void {
    if (process.env.NODE_ENV !== "production") {
      console.debug(...args);
    }
  },

  error(...args: unknown[]): void {
    if (process.env.NODE_ENV !== "production") {
      console.error(...args);
    }
  },
};
